import React, { useId } from 'react';
import { TbRadar, TbEdit } from 'react-icons/tb';
import { isDomainTarget } from '../utils/publicIpTargets';
import './PublicIpOptions.css';

// Shared by the standard/prospecting forms in both portal interfaces.
export default function PublicIpOptions({ target, enabled, mode, onModeChange, value, onChange, disabled }) {
  const id = useId();
  if (!enabled || !isDomainTarget(target)) return null;
  const modes = [
    { key: 'auto', title: 'Auto-discover', Icon: TbRadar },
    { key: 'manual', title: 'Enter manually', Icon: TbEdit },
  ];
  return (
    <fieldset className="public-ip-options" disabled={disabled}>
      <legend>Additional public IPs</legend>
      <div className="public-ip-options-modes" role="radiogroup" aria-label="Public IP source">
        {modes.map(({ key, title, Icon }) => (
          <label key={key} className={`public-ip-options-mode${mode === key ? ' selected' : ''}`}>
            <input type="radio" name={`${id}-mode`} value={key} checked={mode === key}
                   onChange={() => onModeChange(key)} />
            <Icon size={16} aria-hidden="true" /> {title}
          </label>
        ))}
      </div>
      {mode === 'auto' ? (
        <p className="public-ip-options-hint">
          Find organization IPs and dedicated endpoints when the scan starts.
          Hosting/CDN addresses are excluded unless organization evidence supports them.
          Unconfirmed addresses require manual entry.
        </p>
      ) : (
        <>
          <label className="public-ip-options-label" htmlFor={`${id}-addresses`}>Public IPv4 addresses and ranges</label>
          <textarea id={`${id}-addresses`} className="public-ip-options-input" rows={2}
                    value={value} onChange={(e) => onChange(e.target.value)} maxLength={8192}
                    aria-describedby={`${id}-help`}
                    placeholder="8.8.8.8, 9.9.9.1-9.9.9.4, 1.1.1.0/30" />
          <p className="public-ip-options-hint">Separate addresses, start-end ranges, or CIDRs with commas. Leave empty to skip additional IP checks.</p>
        </>
      )}
      <p id={`${id}-help`} className="public-ip-options-hint">
        {mode === 'auto'
          ? 'Checks up to 64 candidate IPs and includes only addresses with supporting organization evidence.'
          : 'Up to 256 unique public IPs. Duplicates are checked once; larger scans take longer.'}
      </p>
    </fieldset>
  );
}
